import {
  ThePackRoot,
  ImageGrid,
  ImageWrapper,
  Header,
  SliderContainer,
} from './ThePack.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image, { StaticImageData } from 'next/image'
import thumb1 from '../../../../../public/assets/reviews/thePack1.webp'
import thumb2 from '../../../../../public/assets/reviews/thePack2.webp'
import thumb3 from '../../../../../public/assets/reviews/thePack3.webp'
import thumb4 from '../../../../../public/assets/reviews/thePack4.webp'
import thumb5 from '../../../../../public/assets/reviews/thePack5.webp'
import { Text } from 'components/Text'
import { SectionTitle } from 'features/Reviews/Reviews.styles'
import Trans from 'next-translate/Trans'
import Slider from 'react-slick'
import { sliderSettings } from 'fixtures/slider'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { TranslationKeys } from 'locales/translationKeys'

export const ThePack = () => {
  const { t } = useTranslation()

  const instaSliderSettings = { ...sliderSettings, dots: false, autoplay: true }

  type postType = {
    imageSrc: StaticImageData
    imageAlt: TranslationKeys
    url: string
  }

  const instaPosts: postType[] = [
    {
      imageSrc: thumb1,
      imageAlt: 'reviews:thePack.image-1',
      url: 'https://www.instagram.com/wefeedraw/reel/DEIEdvTxiln/',
    },
    {
      imageSrc: thumb2,
      imageAlt: 'reviews:thePack.image-2',
      url: 'https://www.instagram.com/wefeedraw/p/DCrGDPmRVAJ/',
    },
    {
      imageSrc: thumb3,
      imageAlt: 'reviews:thePack.image-3',
      url: 'https://www.instagram.com/wefeedraw/p/DBldlrGR6KE/',
    },
    {
      imageSrc: thumb4,
      imageAlt: 'reviews:thePack.image-4',
      url: 'https://www.instagram.com/wefeedraw/p/DEZ5uMiRQ4V/',
    },
    {
      imageSrc: thumb5,
      imageAlt: 'reviews:thePack.image-5',
      url: 'https://www.instagram.com/p/C43N0JVLtKX/',
    },
  ]

  return (
    <>
      <ThePackRoot>
        <Header>
          <SectionTitle color="secondary">{t('reviews:thePack.title')}</SectionTitle>
          <Text
            className="desktop-only"
            align="center"
            color="accent-white"
            size={{ '@initial': 'body', '@bp2': 'h3' }}
          >
            {t('reviews:thePack.subtitle')}
          </Text>
          <Text
            className="mobile-only"
            align="center"
            color="accent-white"
            size={{ '@initial': 'body', '@bp2': 'bodyLarge' }}
          >
            <Trans components={{ br: <br /> }} i18nKey="reviews:thePack.subtitle-mobile" />
          </Text>
        </Header>
        <ImageGrid className="desktop-only">
          {instaPosts.map((post, index) => (
            <ImageWrapper key={index}>
              <a
                style={{ display: 'block' }}
                href={post.url}
                key={index}
                target="_blank"
                rel="noreferrer"
              >
                <Image layout="fill" objectFit="cover" src={post.imageSrc} alt={t(post.imageAlt)} />{' '}
              </a>
            </ImageWrapper>
          ))}
        </ImageGrid>
        <SliderContainer className="mobile-only">
          <Slider {...instaSliderSettings}>
            {instaPosts.map((post, index) => (
              <ImageWrapper key={index}>
                <a href={post.url} key={index} target="_blank" rel="noreferrer">
                  <Image layout="fill" objectFit="cover" src={post.imageSrc} alt={post.imageAlt} />{' '}
                </a>
              </ImageWrapper>
            ))}
          </Slider>
        </SliderContainer>
      </ThePackRoot>
    </>
  )
}
